import * as moment from "moment";
import { BIG_LOGO } from "./contantsTemplate";
moment.locale("es");

export const pdfReporteTurnosTemplate = async (
  turnos: any[],
  campos: any[],
  info: any,
  filter: any
): Promise<any> => {
  let filterData: any;

  if (!info["carretera"]) info["carretera"] = { count: 0, price: 0 };
  if (!info["urbanero"]) info["urbanero"] = { count: 0, price: 0 };
  if (!info["exportacion"]) info["exportacion"] = { count: 0, price: 0 };
  if (!info["reposiciones"]) info["reposiciones"] = { count: 0, price: 0 };
  if (!info["reenturnados"]) info["reenturnados"] = { count: 0, price: 0 };
  if (!info["domicilio"]) info["domicilio"] = { count: 0, price: 0 };
  if (!info["libres"]) info["libres"] = { count: 0, price: 0 };

  const formatter = new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
  });

  let table = [];
  let widthsTable = [];
  const options = campos.length < 11 ? "*" : "auto";
  const headerTable = campos.map((row) => {
    widthsTable.push(options);
    return { text: row, style: "headerTableData" };
  });
  table.push(headerTable);
  turnos.map((turno) => {
    let campoData = campos.map((c) => {
      return { text: turno[c] };
    });
    table.push(campoData);
  });

  if (
    filter.fechaIni ||
    filter.fechaFin ||
    filter.clase.length ||
    filter.patio.length ||
    filter.linea.length ||
    filter.cliente.length ||
    filter.tipoTamanioContenedor.length
  ) {
    let filterTable = [];
    if (filter.fechaIni)
      filterTable.push([
        { text: "FECHA", style: "tableFilter", margin: [20, 0] },
        {
          text: `${moment(filter.fechaIni).format("LL")} ${filter.fechaFin ? " - " + moment(filter.fechaFin).format("LL") : ""
            }`,
          alignment: "center",
        },
      ]);
    if (filter.clase.length)
      filterTable.push([
        { text: "CLASE", style: "tableFilter", margin: [20, 0] },
        { text: filter.clase[0].item_text, alignment: "center" },
      ]);
    if (filter.patio.length)
      filterTable.push([
        { text: "PATIO", style: "tableFilter", margin: [20, 0] },
        { text: filter.patio[0].item_text, alignment: "center" },
      ]);
    if (filter.linea.length)
      filterTable.push([
        { text: "LINEA", style: "tableFilter", margin: [20, 0] },
        { text: filter.linea[0].item_text, alignment: "center" },
      ]);
    if (filter.cliente.length)
      filterTable.push([
        { text: "CLASE", style: "tableFilter", margin: [20, 0] },
        { text: filter.cliente[0].item_text, alignment: "center" },
      ]);
    if (filter.tipoTamanioContenedor.length)
      filterTable.push([
        { text: "CLASE", style: "tableFilter", margin: [20, 0] },
        {
          text: filter.tipoTamanioContenedor[0].item_text,
          alignment: "center",
        },
      ]);

    filterData = {
      table: {
        widths: ["auto", "*"],
        body: filterTable,
      },
      margin: [0, 25, 0, 0],
    };
  }

  return {
    footer: function (currentPage, pageCount) {
      return {
        columns: [
          {
            text: "DIRECCIÓN: VIA ALTERNA KM-7 CALLE 15A # 47 BIS - 11 - BUENAVENTURA",
            style: "footer",
          },
          {
            text: "PÁGINA " + currentPage.toString() + " DE " + pageCount,
            alignment: "right",
            style: "footer",
          },
        ],
        margin: [20, 3, 20, 0],
      };
    },
    pageSize: "legal",
    pageMargins: [20, 20, 20, 25],
    pageOrientation: "landscape",
    content: [
      {
        image: BIG_LOGO,
        alignment: "center",
      },
      {
        text: '"PIKI7 SAS"',
        fontSize: 12,
        bold: true,
        alignment: "center",
      },
      {
        text: "NIT. 900.368.831-9",
        fontSize: 10,
        alignment: "center",
      },
      filterData,
      {
        text: filter.titulo
          ? filter.titulo.toUpperCase()
          : "PLANILLA DE ENTURNAMIENTO",
        alignment: "center",
        fontSize: 14,
        bold: true,
        margin: [0, 18, 0, 18],
      },
      {
        style: "tableContent",
        table: {
          widths: widthsTable,
          headerRows: 1,
          body: table,
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return rowIndex % 2 === 0 ? "#EEEEEE" : null;
          },
        },
        margin: [0, 0, 0, 30],
      },
      {
        text: "RESUMEN ESTADISTICO",
        alignment: "center",
        fontSize: 12,
        bold: true,
        margin: [0, 70, 0, 20],
      },
      {
        style: "tableContent",
        table: {
          widths: ["*", "auto", "auto"],
          body: [
            [
              {
                text: "DETALLE",
                alignment: "right",
                bold: true,
                fillColor: "#95A5A6",
                margin: [10, 0],
              },
              { text: "CANTIDADES", style: "headerTableStatistical" },
              { text: "PRECIOS", style: "headerTableStatistical" },
            ],
            [
              {
                text: "TURNOS TIPOS CARRETERA",
                alignment: "right",
                bold: true,
                margin: [10, 0],
              },
              {
                text: `${info["carretera"].count} tuno(s)`,
                alignment: "center",
                margin: [25, 0],
              },
              {
                text: `${formatter.format(info["carretera"].price)} COP`,
                alignment: "center",
                margin: [25, 0],
              },
            ],
            [
              {
                text: "TURNOS TIPOS URBANERO",
                alignment: "right",
                bold: true,
                margin: [10, 0],
              },
              {
                text: `${info["urbanero"].count} tuno(s)`,
                alignment: "center",
                margin: [25, 0],
              },
              {
                text: `${formatter.format(info["urbanero"].price)} COP`,
                alignment: "center",
                margin: [25, 0],
              },
            ],
            [
              {
                text: "TURNOS TIPOS EXPORTACION",
                alignment: "right",
                bold: true,
                margin: [10, 0],
              },
              {
                text: `${info["exportacion"].count} tuno(s)`,
                alignment: "center",
                margin: [25, 0],
              },
              {
                text: `${formatter.format(info["exportacion"].price)} COP`,
                alignment: "center",
                margin: [25, 0],
              },
            ],
            [
              {
                text: "TURNOS TIPOS REPOSICIONES",
                alignment: "right",
                bold: true,
                margin: [10, 0],
              },
              {
                text: `${info["reposiciones"].count} tuno(s)`,
                alignment: "center",
                margin: [25, 0],
              },
              {
                text: `${formatter.format(info["reposiciones"].price)} COP`,
                alignment: "center",
                margin: [25, 0],
              },
            ],
            [
              {
                text: "TURNOS TIPOS DOMICILIO",
                alignment: "right",
                bold: true,
                margin: [10, 0],
              },
              {
                text: `${info["domicilio"].count} tuno(s)`,
                alignment: "center",
                margin: [25, 0],
              },
              {
                text: `${formatter.format(info["domicilio"].price)} COP`,
                alignment: "center",
                margin: [25, 0],
              },
            ],
            [
              {
                text: "REENTURNADOS",
                alignment: "right",
                bold: true,
                margin: [10, 0],
              },
              {
                text: `${info["reenturnados"].count} tuno(s)`,
                alignment: "center",
                margin: [25, 0],
              },
              {
                text: `${formatter.format(info["reenturnados"].price)} COP`,
                alignment: "center",
                margin: [25, 0],
              },
            ],
            [
              {
                text: "LIBRES",
                alignment: "right",
                bold: true,
                margin: [10, 0],
              },
              {
                text: `${info["libres"].count} tuno(s)`,
                alignment: "center",
                margin: [25, 0],
              },
              {
                text: `${formatter.format(info["libres"].price)} COP`,
                alignment: "center",
                margin: [25, 0],
              },
            ],
            [
              {
                text: "TOTAL",
                alignment: "right",
                bold: true,
                margin: [10, 0],
              },
              {
                text: `${info["carretera"].count +
                  info["urbanero"].count +
                  info["exportacion"].count +
                  info["reposiciones"].count +
                  info["reenturnados"].count +
                  info["domicilio"].count +
                  info["libres"].count
                  } tuno(s)`,
                alignment: "center",
                margin: [25, 0],
              },
              {
                text: `${formatter.format(
                  info["carretera"].price +
                  info["urbanero"].price +
                  info["exportacion"].price +
                  info["reposiciones"].price +
                  info["reenturnados"].price +
                  info["domicilio"].price +
                  info["libres"].price
                )} COP`,
                alignment: "center",
                margin: [25, 0],
              },
            ],
          ],
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return rowIndex % 2 === 0 ? "#EEEEEE" : null;
          },
        },
      },
    ],
    styles: {
      headerTableData: {
        bold: true,
        fillColor: "#95A5A6",
      },
      headerTableStatistical: {
        alignment: "center",
        bold: true,
        fillColor: "#95A5A6",
        margin: [10, 0],
      },
      footer: {
        opacity: 0.4,
        fontSize: 11,
      },
      tableFilter: {
        bold: true,
      },
      tableContent: {
        fontSize: 10,
      },
    },
  };
};
